import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useContent, rich } from "@/lib/content";
import { scrollToId } from "@/lib/smooth";
import { Reveal, SectionTitle } from "./Primitives";

const Fader = ({ images, interval }) => {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % images.length), interval);
    return () => clearInterval(t);
  }, [images.length, interval]);
  return (
    <div className="absolute inset-0">
      {images.map((src, k) => (
        <motion.img
          key={src}
          src={src}
          alt=""
          animate={{ opacity: k === i ? 1 : 0, scale: k === i ? 1.04 : 1.12 }}
          transition={{ duration: 1.6, ease: "easeOut" }}
          className="absolute inset-0 h-full w-full object-cover"
        />
      ))}
    </div>
  );
};

const LAYOUT = ["md:col-span-7", "md:col-span-5", "md:col-span-5", "md:col-span-7"];

export const Pillars = () => {
  const { PILLARS, PRODUCTS, TEXTS: T } = useContent();
  // La tarjeta "Otros Productos" usa las fotos de la sección Otros Productos
  const productImgs = (Array.isArray(PRODUCTS) ? PRODUCTS : []).map((x) => x?.img).filter(Boolean);
  return (
  <section data-testid="pillars-section" className="mx-auto max-w-[1400px] px-5 pb-28 md:px-10 md:pb-40">
    <div className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
      <SectionTitle eyebrow={T.pil_eyebrow} title={rich(T.pil_title)} />
      <Reveal>
        <p className="max-w-sm font-sans text-sand">{T.pil_sub}</p>
      </Reveal>
    </div>
    <div className="grid grid-cols-1 gap-5 md:grid-cols-12">
      {PILLARS.map((p, i) => (
        <Reveal key={p.key} delay={i * 0.1} className={`${LAYOUT[i % LAYOUT.length]} h-full min-h-[260px] sm:min-h-[320px] md:min-h-[420px]`}>
          <button
            data-testid={`pillar-card-${p.key}`}
            onClick={() => scrollToId(p.target)}
            className="group relative flex h-full min-h-[inherit] w-full flex-col justify-end overflow-hidden rounded-3xl border border-gold/15 p-7 text-left md:p-9"
          >
            <Fader images={p.key === "productos" && productImgs.length ? productImgs : p.images} interval={4000} />
            <div className="absolute inset-0 bg-gradient-to-t from-espresso via-espresso/50 to-transparent transition-opacity duration-500 group-hover:opacity-80" />
            <div className="relative">
              <p className="font-display text-base italic text-gold sm:text-lg">{p.de}</p>
              <h3 className="mt-1 font-display text-2xl text-cream sm:text-3xl md:text-4xl">{p.title}</h3>
              <p className="mt-2 max-w-md font-sans text-[13px] leading-relaxed text-sand sm:mt-3 sm:text-sm">{p.text}</p>
              <span className="mt-6 inline-flex items-center gap-2 font-sans text-xs uppercase tracking-[0.25em] text-cream">
                {p.cta}
                <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
              </span>
            </div>
          </button>
        </Reveal>
      ))}
    </div>
  </section>
  );
};
